export function dateToDate(sDate) {
  if (!sDate) return '';

  let date = new Date(sDate);
  let dd = date.getDate();
  if (dd < 10) dd = '0' + dd;
  let mm = date.getMonth() + 1;
  if (mm < 10) mm = '0' + mm;
  let yyyy = date.getFullYear();
  if (yyyy < 10) yyyy = '0' + yyyy;

  const dt = `${dd}.${mm}.${yyyy}`;
  return dt;
}


export function dateToDateTime(sDate) {
  if (!sDate) return '';

  let date = new Date(sDate);
  let dd = date.getDate();
  if (dd < 10) dd = '0' + dd;
  let mm = date.getMonth() + 1;
  if (mm < 10) mm = '0' + mm;
  let yyyy = date.getFullYear();
  if (yyyy < 10) yyyy = '0' + yyyy;

  let hh = date.getHours();
  if (hh < 10) hh = '0' + hh;

  let mn = date.getMinutes();
  if (mn < 10) mn = '0' + mn;

  const dt = `${dd}.${mm}.${yyyy} ${hh}:${mn}`;
  return dt;
}

export function toDate(date, format) {
  if (!date) return '';

  let dt = new Date(date);
  let dd = dt.getDate();
  if (dd < 10) dd = '0' + dd;
  let mm = dt.getMonth() + 1;
  if (mm < 10) mm = '0' + mm;
  let yyyy = dt.getFullYear();
  if (yyyy < 10) yyyy = '0' + yyyy;

  let hh = dt.getHours();
  if (hh < 10) hh = '0' + hh;

  let mn = dt.getMinutes();
  if (mn < 10) mn = '0' + mn;

  let ss = dt.getSeconds();
  if (ss < 10) ss = '0' + ss;

  if (format) return format(yyyy, mm, dd, hh, mn, ss);
  return `${yyyy}-${mm}-${dd}`;
}

export function toMoney(nStr)
{
  if (nStr !== 0 && !nStr) return;

  nStr = parseFloat(nStr).toFixed(2);

  nStr += '';
  let x = nStr.split('.');
  let x1 = x[0];
  let x2 = x.length > 1 ? ',' + x[1] : '';
  const rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + '\u00A0' + '$2');
  }
  return x1 + x2;
}

export function isnull(value, defaultValue) {
  if (value === 0 || value === false) return value;

  return value || defaultValue;
}

export function toBool(value) {
  const type = typeof(value);
  if (type === 'boolean') {
    return value;
  }
  else if (type === 'number') {
    if (value === 1) return true;
    if (value === 0) return false;
  }
  else if (type === 'string') {
    if (value === 'true') return true;
    if (value === 'false') return false;

    if (value === 'yes') return true;
    if (value === 'no') return false;

    if (value === 'y') return true;
    if (value === 'n') return false;

    if (value === 'да') return true;
    if (value === 'нет') return false;

    if (value === 'д') return true;
    if (value === 'н') return false;
  }

  return !!value;
}

export function setOrDrop(obj, set) {
  const setFields = Object.keys(set);
  setFields.forEach(field => {
    const value = set[field];
    if (value !== false && value !== 0 && !value) delete obj[field];
    else obj[field] = set[field];
  });

  if (Object.keys(obj).length <= 0) obj = null;

  return obj;
}

export function getCorrect(number, ending1, ending2, ending5)
{
  if (!ending1) ending1 = '';
  if (!ending2) ending2 = '';
  if (!ending5) ending5 = '';

  if (!number) number = 0;

  if (number === 0)
    return ending5;

  number = number % 100;
  if (number >= 11 && number <= 19)
    return ending5;

  let i = number % 10;
  switch (i)
  {
    case 1:
      return ending1;
    case 2:
    case 3:
    case 4:
      return ending2;
    default:
      return ending5;
  }
}


// WEBPACK FOOTER //
// ./src/data/converter.js